import * as React from 'react';
import { components } from 'react-select';
import { GetControlLabel } from './types';

type Props = {
  getControlLabel?: GetControlLabel;
} & React.ComponentProps<typeof components['SingleValue']>;

export const SingleValue: React.FC<Props> = ({ children, ...props }) => {
  if (
    props.hasValue &&
    typeof props.selectProps.getControlLabel !== 'undefined'
  ) {
    children = props.selectProps.getControlLabel(props.getValue());
  }

  return <components.SingleValue {...props}>{children}</components.SingleValue>;
};
